import { handleActions } from 'redux-actions';

const defaultState = { global: 'UA-111299588-4', shard: null };

export default handleActions(
  {},

  defaultState
);
